// Sweden Startup Ecosystem Statistics 2025
export const swedenStats2025 = {
  // Company Statistics
  activeStartups: 8573,
  allFundedCompanies: 8573,
  vcBackedCompanies: 5098,
  seedOpportunities: 1097,
  womanFoundedCompanies: 603,
  companiesWithPatents: 792,
  universitySpinouts: 435,
  unicorns: 52,
  scaleups: 371,

  // Exit Data 2025
  exits: {
    realised: 76.6, // M USD
    total: 76.6, // M USD
  },

  // Funding Rounds 2025 (in EUR)
  fundingRounds: {
    over250m: 273, // M EUR
    range100to250m: 568, // M EUR
    range40to100m: 438, // M EUR
    range15to40m: 305, // M EUR
    range4to15m: 231, // M EUR
    range1to4m: 128, // M EUR
    range0to1m: 17.7, // M EUR
    total: 2.0, // B EUR
  },

  // Breakdown by categories
  fundingBySize: [
    { category: '€250m+', amount: 273, color: 'hsl(var(--chart-color-1))' },
    { category: '€100-250m', amount: 568, color: 'hsl(var(--chart-color-2))' },
    { category: '€40-100m', amount: 438, color: 'hsl(var(--chart-color-3))' },
    { category: '€15-40m', amount: 305, color: 'hsl(var(--chart-color-4))' },
    { category: '€4-15m', amount: 231, color: 'hsl(var(--chart-color-5))' },
    { category: '€1-4m', amount: 128, color: 'hsl(var(--chart-color-6))' },
    { category: '€0-1m', amount: 17.7, color: 'hsl(var(--chart-color-7))' },
  ],

  // Key Insights Data
  keyInsights: {
    totalFunding2025: 2.0, // B EUR (Total 2025 funding)
    fundingChange: '+15%', // Change from previous year
    scaleupJobPercentage: 5.2, // 5.2% of all jobs
    scaleupCompanyPercentage: 0.19, // 0.19% of Nordic SMEs
    taxRevenue: 890, // M EUR tax revenue last 10 years
    taxRevenueChange: '-7%', // Change from previous year
    femaleFoundersPercentage: 9.5, // 9.5% startups with female founders
    femaleFoundersChange: '+2%', // Change from previous year
    jobsCreated: 156000, // Jobs created in past year
    jobsCreatedChange: '-2%', // Change from previous year
    deeptechStartups: 537, // Currently active deeptech startups
    deeptechGrowth: '+7.4%', // Growth in deeptech
  },

  // KPI Display Data (for StatisticsSection)
  kpiData: {
    taxRevenue: 890, // M EUR tax revenue
    totalJobs: 156000, // Total jobs created
    totalInvestment: 2.0, // B EUR total investment
  },
};

// Company categories updated with new data
export const companyCategories2025 = {
  patents: {
    total: 792,
    breakdown: {
      ai: Math.round(792 * 0.23), // ~182
      lifescience: Math.round(792 * 0.32), // ~254
      deeptech: Math.round(792 * 0.28), // ~222
      climate: Math.round(792 * 0.17), // ~135
    },
  },
  spinouts: {
    total: 435,
    topUniversities: [
      { name: 'KTH Royal Institute of Technology', count: 89 },
      { name: 'Karolinska Institute', count: 67 },
      { name: 'Chalmers University', count: 58 },
      { name: 'Lund University', count: 45 },
      { name: 'Uppsala University', count: 39 },
      { name: 'Stockholm University', count: 34 },
      { name: 'Other Universities', count: 103 },
    ],
  },
};

export default swedenStats2025;
